<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a> <em>For Cam and Sam, arms crossed, love, love.<br/>And for daughters of mothers everywhere.</em></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?32c1cf82